import * as render from './render.pug'
import { NotificationList } from './list/index.js'
import { vOnClickOutside } from '@vueuse/components'
import { useToggle } from '~vueutil/useToggle.js'
import { useNotificationStore } from '../../layout/notification/store.js'
import './style.css'

export const Notification = {
  ...render,
  props: {},
  components: {
    NotificationList
  },
  directives: {
    onClickOutside: vOnClickOutside
  },
  setup (props) {
    const [show, toggle] = useToggle()

    const { stat } = useNotificationStore()
    return {
      show,
      toggle,
      stat
    }
  }
}
